var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#828FA3",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.728 0 2.122 2.122L2.122 14.85 0 12.728z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.122 2.122 0 14.85 12.728l-2.122 2.122z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.d4ca9e0d2a82f7ea4ae08238a42f84ed.svg";
export { ForwardRef as ReactComponent };